import {Injectable} from '@angular/core';
import {ApiService, ApiServiceContext} from '@app/services/api.service';
import {Observable} from 'rxjs';
import {FordocUser} from '@app/models/form/fordoc-user.model';
import {catchError} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class FordocUserService extends ApiService {

  constructor(ctx: ApiServiceContext) {
    super(ctx);
  }

  get(uuid: string): Observable<FordocUser> {
    return this.http.get<FordocUser>(`/api/fordoc-users/${uuid}`).pipe(catchError(this.handleError));
  }

  getAll(): Observable<FordocUser[]> {
    return this.http.get<FordocUser[]>('/api/fordoc-users/').pipe(catchError(this.handleError));
  }

  getUlgMembers() {
    return this.http.get<FordocUser[]>('/api/fordoc-users/member-ceimg/ULG').pipe(catchError(this.handleError));
  }

  getUclMembers() {
    return this.http.get<FordocUser[]>('/api/fordoc-users/member-ceimg/UCL').pipe(catchError(this.handleError));
  }

  getUlbMembers() {
    return this.http.get<FordocUser[]>('/api/fordoc-users/member-ceimg/ULB').pipe(catchError(this.handleError));
  }

  getUnrMembers() {
    return this.http.get<FordocUser[]>('/api/fordoc-users/member-ceimg/UNR').pipe(catchError(this.handleError));
  }

  getSponsors(): Observable<FordocUser[]> {
    /*
    console.warn('/!\\ /!\\ /!\\ Hardcoded sponsors list');
    return Observable.of(SPONSORS_MOCK);
    */
    return this.http.get<FordocUser[]>('/api/fordoc-users/sponsor').pipe(catchError(this.handleError));
  }

  getMainUniversity(uuid: string) {
    return this.http.get<string>(`/api/fordoc-users/${uuid}/university`).pipe(catchError(this.handleError));
  }

}
